var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('div', {
    staticClass: "d-flex overflow-auto"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', {
    staticClass: "text-truncate"
  }, [_c('th', {
    staticClass: "sticky-col text-center"
  }, [_vm._v("#")]), _c('th', {
    staticClass: "text-truncate"
  }, [_vm._v("Trip Info")]), _c('th', [_vm._v("Start Date")]), _c('th', [_vm._v("End Date")]), _c('th', [_vm._v("Project")]), _c('th', {
    staticStyle: {
      "width": "250px"
    }
  }, [_vm._v("POL Remark")]), _c('th', {
    staticStyle: {
      "width": "250px"
    }
  }, [_vm._v("POD Remark")])])]), _c('tbody', _vm._l(_vm.unfinishedTrip, function (val, index) {
    var _val$tripRecord2, _val$tripRecord3, _val$tripRecord3$port, _val$tripRecord4, _val$tripRecord4$port, _val$tripRecord5, _val$tripRecord6, _val$tripRecord7, _val$tripRecord8, _val$tripRecord9, _val$tripRecord0, _val$tripRecord0$subP, _val$tripRecord1, _val$tripRecord10;
    return _c('tr', {
      key: index,
      staticClass: "cursor-pointer",
      on: {
        "click": function click($event) {
          var _val$tripRecord;
          _vm.tripId = (_val$tripRecord = val.tripRecord) === null || _val$tripRecord === void 0 ? void 0 : _val$tripRecord.id;
        }
      }
    }, [_c('td', {
      staticClass: "sticky-col text-center"
    }, [_c('b-form-checkbox', {
      attrs: {
        "checked": _vm.tripId === ((_val$tripRecord2 = val.tripRecord) === null || _val$tripRecord2 === void 0 ? void 0 : _val$tripRecord2.id)
      }
    })], 1), _c('td', {
      staticClass: "text-truncate"
    }, [_c('div', {
      staticClass: "d-flex flex-column"
    }, [_c('div', {
      staticClass: "d-flex align-items-center text-primary"
    }, [_c('i', {
      staticClass: "fas fa-map-pin mr-2"
    }), _vm._v(" " + _vm._s(val === null || val === void 0 ? void 0 : (_val$tripRecord3 = val.tripRecord) === null || _val$tripRecord3 === void 0 ? void 0 : (_val$tripRecord3$port = _val$tripRecord3.portLoading) === null || _val$tripRecord3$port === void 0 ? void 0 : _val$tripRecord3$port.portName) + " ")]), _c('div', {
      staticClass: "dashed-border"
    }), _c('div', {
      staticClass: "d-flex align-items-center text-primary"
    }, [_c('i', {
      staticClass: "fa fa-map-pin mr-2"
    }), _vm._v(" " + _vm._s(val === null || val === void 0 ? void 0 : (_val$tripRecord4 = val.tripRecord) === null || _val$tripRecord4 === void 0 ? void 0 : (_val$tripRecord4$port = _val$tripRecord4.portDischarge) === null || _val$tripRecord4$port === void 0 ? void 0 : _val$tripRecord4$port.portName) + " ")])])]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(" " + _vm._s((_val$tripRecord5 = val.tripRecord) !== null && _val$tripRecord5 !== void 0 && _val$tripRecord5.startDate ? _vm.moment((_val$tripRecord6 = val.tripRecord) === null || _val$tripRecord6 === void 0 ? void 0 : _val$tripRecord6.startDate, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(" " + _vm._s((_val$tripRecord7 = val.tripRecord) !== null && _val$tripRecord7 !== void 0 && _val$tripRecord7.endDate ? _vm.moment((_val$tripRecord8 = val.tripRecord) === null || _val$tripRecord8 === void 0 ? void 0 : _val$tripRecord8.endDate, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(_vm._s((_val$tripRecord9 = val.tripRecord) === null || _val$tripRecord9 === void 0 ? void 0 : _val$tripRecord9.subProject.project.projectName) + " - " + _vm._s((_val$tripRecord0 = val.tripRecord) === null || _val$tripRecord0 === void 0 ? void 0 : (_val$tripRecord0$subP = _val$tripRecord0.subProject) === null || _val$tripRecord0$subP === void 0 ? void 0 : _val$tripRecord0$subP.name))]), _c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s((_val$tripRecord1 = val.tripRecord) === null || _val$tripRecord1 === void 0 ? void 0 : _val$tripRecord1.polRemark))]), _c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s((_val$tripRecord10 = val.tripRecord) === null || _val$tripRecord10 === void 0 ? void 0 : _val$tripRecord10.podRemark))])]);
  }), 0)])]), _vm.unfinishedTrip.length > 0 ? _c('div', {
    staticClass: "mt-3"
  }, [_c('b-pagination', {
    attrs: {
      "total-rows": _vm.meta.total,
      "per-page": _vm.meta.perPage,
      "first-number": "",
      "align": "center"
    },
    on: {
      "change": _vm.fetchUnfinishTrip
    },
    model: {
      value: _vm.page,
      callback: function callback($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  })], 1) : _c('p', {
    staticClass: "text-center my-4"
  }, [_vm._v("List Trip tidak ada.")])]), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('div', {
    staticClass: "d-flex align-items-center justify-content-end"
  }, [_c('button', {
    staticClass: "btn btn-outline-primary btn-menu mr-2",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.closeSidebar('assign-trip');
      }
    }
  }, [_vm._v(" Cancel & Close ")]), _c('button', {
    staticClass: "btn btn-primary btn-menu",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onSaveSwapTrip
    }
  }, [_vm._v(" Assign & Submit ")])])])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }